import React from 'react';
import logo from '../assets/benjamin-hove-logo.svg';
import './Header.css';

export default function Header() {

    return (
        <div className='header'>
            <img src={logo} className="App-logo" alt="logo"/>

            <div>
                <nav>
                    <a href="#about">About</a>
                    <a href="#projects">Projects</a>
                    <a href="https://dev.to/benjaminh" target='blank'>Blog</a>
                    <a href="#contact">Contact</a>
                </nav>
            </div>
           
        </div>
    )
}